/**
 * Sample content used by the UI until the backend is seeded.
 * Mirrors the API shape (package / addon / category) so swapping to live
 * data is a drop-in change. Images use Unsplash placeholders.
 */

export const categories = [
  { id: 'wedding', name: 'Weddings', icon: '💍' },
  { id: 'birthday', name: 'Birthdays', icon: '🎂' },
  { id: 'corporate', name: 'Corporate', icon: '🏢' },
  { id: 'concert', name: 'Concerts', icon: '🎤' },
  { id: 'baby', name: 'Baby Shower', icon: '🍼' },
  { id: 'anniversary', name: 'Anniversary', icon: '💖' },
];

const img = (q) =>
  `https://images.unsplash.com/${q}?auto=format&fit=crop&w=900&q=80`;

export const packages = [
  {
    id: 'p1',
    title: 'Royal Wedding Grandeur',
    category: 'Weddings',
    categoryId: 'wedding',
    price: 250000,
    rating: 4.9,
    duration: '2 Days',
    tag: 'Most Popular',
    cover: img('photo-1519225421980-715cb0215aed'),
    gallery: [
      img('photo-1519225421980-715cb0215aed'),
      img('photo-1465495976277-4387d4b0b4c6'),
      img('photo-1511795409834-ef04bbd61622'),
    ],
    summary:
      'A regal, full-service wedding experience with stage, décor, catering and cinematography.',
    features: ['Stage & Mandap Décor', 'Premium Catering (500 pax)', 'Cinematic Photography', 'DJ & Lighting'],
  },
  {
    id: 'p2',
    title: 'Birthday Bash Deluxe',
    category: 'Birthdays',
    categoryId: 'birthday',
    price: 45000,
    rating: 4.8,
    duration: '6 Hours',
    tag: 'Trending',
    cover: img('photo-1530103862676-de8c9debad1d'),
    gallery: [img('photo-1530103862676-de8c9debad1d'), img('photo-1464349095431-e9a21285b5f3')],
    summary: 'Themed birthday celebration with balloon décor, cake, games and a live host.',
    features: ['Theme Décor', 'Designer Cake', 'Anchor & Games', 'Photo Booth'],
  },
  {
    id: 'p3',
    title: 'Corporate Summit Pro',
    category: 'Corporate',
    categoryId: 'corporate',
    price: 180000,
    rating: 4.7,
    duration: '1 Day',
    cover: img('photo-1505373877841-8d25f7d46678'),
    gallery: [img('photo-1505373877841-8d25f7d46678'), img('photo-1540575467063-178a50c2df87')],
    summary: 'Professional conference setup with AV, stage, branding and hospitality.',
    features: ['LED Stage & AV', 'Brand Setup', 'Hospitality Desk', 'Live Streaming'],
  },
  {
    id: 'p4',
    title: 'Live Concert Spectacle',
    category: 'Concerts',
    categoryId: 'concert',
    price: 500000,
    rating: 5.0,
    duration: '1 Night',
    tag: 'Premium',
    cover: img('photo-1492684223066-81342ee5ff30'),
    gallery: [img('photo-1492684223066-81342ee5ff30'), img('photo-1459749411175-04bf5292ceea')],
    summary: 'End-to-end concert production with stage, sound, lights and crowd management.',
    features: ['Concert Stage', 'Line-array Sound', 'Intelligent Lighting', 'Security & Crowd Mgmt'],
  },
  {
    id: 'p5',
    title: 'Baby Shower Bliss',
    category: 'Baby Shower',
    categoryId: 'baby',
    price: 35000,
    rating: 4.9,
    duration: '4 Hours',
    cover: img('photo-1555252333-9f8e92e65df9'),
    gallery: [img('photo-1555252333-9f8e92e65df9')],
    summary: 'Pastel-themed baby shower with floral décor, games and dessert table.',
    features: ['Floral Backdrop', 'Dessert Table', 'Games & Host', 'Return Gifts'],
  },
  {
    id: 'p6',
    title: 'Anniversary Romance',
    category: 'Anniversary',
    categoryId: 'anniversary',
    price: 60000,
    rating: 4.8,
    duration: '5 Hours',
    cover: img('photo-1464366400600-7168b8af9bc3'),
    gallery: [img('photo-1464366400600-7168b8af9bc3')],
    summary: 'Romantic candle-light setup with live music, décor and curated dinner.',
    features: ['Candlelight Décor', 'Live Acoustic', 'Curated Dinner', 'Photography'],
  },
];

export const addOns = [
  { id: 'a1', title: 'Drone Cinematography', price: 25000 },
  { id: 'a2', title: 'Live Streaming (HD)', price: 15000 },
  { id: 'a3', title: 'Premium Floral Décor', price: 40000 },
  { id: 'a4', title: 'Celebrity Anchor', price: 60000 },
  { id: 'a5', title: 'Fireworks Show', price: 35000 },
  { id: 'a6', title: 'Luxury Car Entry', price: 20000 },
  { id: 'a7', title: 'Photo Booth 360°', price: 18000 },
  { id: 'a8', title: 'Valet Parking', price: 12000 },
];

export const banners = [
  {
    id: 'b1',
    title: 'Crafting Unforgettable Moments',
    subtitle: 'Premium event planning, end to end.',
    image: img('photo-1519671482749-fd09be7ccebf'),
  },
];

export const testimonials = [
  { id: 't1', name: 'Aarav & Diya', role: 'Wedding', text: 'Event Story turned our dream wedding into reality. Flawless execution!', avatar: 'https://i.pravatar.cc/120?img=12' },
  { id: 't2', name: 'Meera Kapoor', role: 'Birthday', text: 'The themed décor blew everyone away. Highly professional team.', avatar: 'https://i.pravatar.cc/120?img=32' },
  { id: 't3', name: 'TechNova Inc.', role: 'Corporate Summit', text: 'Seamless conference production. Our brand looked world-class.', avatar: 'https://i.pravatar.cc/120?img=15' },
];

export const stats = [
  { label: 'Events Delivered', value: '1,200+' },
  { label: 'Happy Clients', value: '950+' },
  { label: 'Cities Covered', value: '40+' },
  { label: 'Years of Magic', value: '8+' },
];
